import React, { Component } from 'react';
import { connect } from 'react-redux';

import paymentMethodsDecorator from 'billing/paymentMethods/decorator';
import { pad } from 'helpers/formatters';

import CardIcon from 'billing/CardIcon';
import SelectPaymentMethod from 'billing/paymentMethods/SelectPaymentMethod';
import NewCard from 'billing/paymentMethods/NewCard';
import Box from 'common/Box';
import Button from 'forms/Button';
import Warning from 'notifications/Warning';
import Info from 'notifications/Info';

import styles from './index.module.css';
import { checkout } from './actions';

export class PayPurchase extends Component {
  state = {
    showCardPicker: false,
    showNewCard: false
  }

  showNewCard = () => {
    this.setState({
      showCardPicker: false,
      showNewCard: true,
    });
  }

  showCardPicker = () => {
    this.setState({
      showCardPicker: true,
      showNewCard: false,
    });
  }

  render() {
    const { defaultPaymentMethod, checkout, id, message, onComplete } = this.props;
    return (
      <div className="PayPurchase">
        {this.state.showCardPicker &&
          <SelectPaymentMethod onNewCard={this.showNewCard} />
        }
        {(this.state.showNewCard || !defaultPaymentMethod) &&
          <React.Fragment>
            <h2>
              Add Card
              <span className={styles.cancel} onClick={this.showCardPicker}>(cancel)</span>
            </h2>
            <NewCard onSubmitSuccess={this.showCardPicker} />
          </React.Fragment>
        }
        <Warning name="newCard" />
        <Info name="newCard" />
        <Box>
          <h6 className={styles.header}>Payment Method</h6>
          {defaultPaymentMethod ? (
            <div className={styles.defaultPaymentMethod} onClick={this.showCardPicker}>
              <span>
                <span>
                  <span className={styles.dots}>•••• •••• ••••</span>
                  <span className={styles.lastFour}>
                    {defaultPaymentMethod.card_last_four}
                  </span>
                </span>
                <span className={styles.cardExp}>
                  {pad(defaultPaymentMethod.expiration_month, 2)}/{defaultPaymentMethod.expiration_year}
                </span>
              </span>
              <span className={styles.cardIcon}>
                <CardIcon cardType={defaultPaymentMethod.card_brand} color="dark" /> 
              </span>
              <span>
                change
              </span>
            </div>
          ) : (
            <div className={styles.defaultPaymentMethod}>
              <span>
                Please add a payment method above.
              </span>
            </div>
          )}
          <div className={styles.button}>
            <Button onClick={() => checkout(id, defaultPaymentMethod.id, onComplete, message)} disabled={!defaultPaymentMethod}>Submit Payment</Button>
          </div>
        </Box>
        <Warning name="payPurchase" />
      </div>
    );
  }
}

const mapDispatchToProps = {
  checkout,
}

export default paymentMethodsDecorator(connect(
  null,
  mapDispatchToProps
)(PayPurchase));
